const ExternalUrls = {
  IntelligenceHub: 'https://aci.aero/programs-and-services/intelligence-hub/',
  PrivacyPolicy: 'https://aci.aero/aci-world-privacy-policy/',
};

export default ExternalUrls;
